module.exports = __webpack_public_path__ + "static/media/DIAGONAL.7a87a89f.svg";